import { Injectable } from '@angular/core';
import { CommonServiceModule } from 'src/app/common-service/common-service.module';
import { ServerURLService } from 'src/app/common-service/serverURL.service';


@Injectable({
    providedIn: CommonServiceModule
})
export class EligibilityCertificateUrlServices {
    constructor(public serverURL: ServerURLService) { }
   
        // Eligibility service - Uncomment while deploy in server
        ecApplicantInfo = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/applicant-info`;   
        ecApplicantRegistrationInfo = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/applicant-ec-registration-info`;

        ecRegistration = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-request`;
        ecStatuschange = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-statuschange`;

        deficientStatusUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/deficientStatusUpload`;
        ecCourseList = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getAllCourses`;
         
        retrieveECForApproval = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getEligibilityCertificatesForApproval`;
        ecApprovalInfo = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/get_ec_info_for_approval`;
        getEligibilityCertificateDetails = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getEligibilityCertificateDetails`;
        getApplicantDeficientComments = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getApplicantDeficientComments`;
        getECAssignedUserIdDetails = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getECAssignedUserIdDetails`;
        updateECApprovalStatus = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/update-applicant-ec-status`;
        applicantProfileFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-image-upload`;
        applicantsignFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-sign-upload`;
        applicantDocumentsFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-files-upload`;
       
        applicantAuthorityFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-authority-upload`;

        applicantEntranceFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-entrance-upload`;
        
        applicantSchoolFileUpload= `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-school-upload`;

        applicantpassportFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-passport-upload`;

        applicantRelevantFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-relevant-upload`;

        applicantadmissionFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-admission-upload`;

        applicantclearanceFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-clearance-upload`;
        
        applicantbdsmarkFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-bdsmark-upload`;

        applicantdegreeFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-degree-upload`;

        applicantInstitutionFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-institution-upload`;

        applicantprospectusFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-prospectus-upload`;

        applicantReservedFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-reserved-upload`;

        applicantcertificateSchoolUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-certificate-upload`;


        applicantTwelvethFileUpload = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-marks-upload`;
      
        deleteApplicantUploadedDocument = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/ec-delete-applicant-document`;
        ecDocumentDelete=`${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/delete_ec_documents`;
        applicantProfileUrl = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getEcApplicantImage/`;
        applicantsignUrl = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getEcApplicantSign/`;
        applicantDocumentUrl = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getEcApplicantDocument/`;
        applicantEligibilityCertificateUrl = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/getApplicantEligibilityCertificate/`;
        getECListCount = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibility/get_ec_list_count`;

        //New Assign Role
        getEligibilityDashboardList = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/get_eligibility_dashboard_list`;
        getEligibilityTrackDashboardList = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/get_eligibility_track_dashboard_list`;
        findAllEligibilityStatus = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/find_all_eligibility_status`;
        assignEligibilityCertificate = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/assign_eligibility_certificate_section`;
        getEligibilityProcessHistory = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/get_eligibility_process_history_list`;
        eligibilityWorkflowWithDocument = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/eligibility_workflow_with_document`;
        getEligibilityNoteSheetPurpose = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/find_all_eligibility_notesheet_purpose`;
        getEligibilityViewPdf = `${this.serverURL.apiServerAddress}dci-eligibility/api/v1/eligibilityworkflow/get_eligibility_view_pdf`;

}
export const urlServiceProvider = [
    EligibilityCertificateUrlServices
];
